import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Home } from "../pages/Home";
import { Shop } from "../pages/Shop";
import { ProductPage } from "../pages/ProductPage";
export function AppRoutes() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  return <main className={`flex-1 ${isHome ? "" : "pt-24 lg:pt-[104px]"}`} data-id="element-27" data-mp="2425pu4c0p9vo">
      <AnimatePresence mode="wait" initial={false} data-id="element-28" data-mp="241vyodf8kwoe">
        <motion.div key={location.pathname} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-29" data-mp="2837ook20vjx4">
          <Routes location={location} data-id="element-30" data-mp="2i15cx7jvtgpq">
            <Route path="/" element={<Home data-id="element-32" data-mp="ipuisqe9hntw" />} data-id="element-31" data-mp="ip2n7fknzq3m" />
            <Route path="/shop" element={<Shop data-id="element-34" data-mp="ir5nqtjg11ml" />} data-id="element-33" data-mp="iqdrdgi0uzv9" />
            <Route path="/product/:slug" element={<ProductPage data-id="element-36" data-mp="nop0fp0ht6cf" />} data-id="element-35" data-mp="nnnqxoz4krwt" />
            <Route path="*" element={<Home data-id="element-38" data-mp="26grfiz55i39o" />} data-id="element-37" data-mp="nq05ds5ock54" />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </main>;
}